<template>
  <svg
    width="42"
    height="42"
    viewBox="0 0 42 42"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="21.125"
      cy="21.125"
      r="19.125"
      stroke-width="3"
      class="stroke"
    />
    <path
      d="M23.4531 25.1875H19.5469L17.9844 9.40625H25.0156L23.4531 25.1875Z"
      class="fill"
    />
    <path
      d="M21.5 32.8438C23.1612 32.8438 24.5078 31.5146 24.5078 29.875C24.5078 28.2354 23.1612 26.9062 21.5 26.9062C19.8388 26.9062 18.4922 28.2354 18.4922 29.875C18.4922 31.5146 19.8388 32.8438 21.5 32.8438Z"
      class="fill"
    />
  </svg>
</template>
<style lang="scss" scoped>
svg .fill {
  fill: #fba45b;
}
svg .stroke {
  stroke: #fba45b;
}
</style>
